<template>
  <div>
    <div class="form__success" v-if="form.submitStatus === 'OK'">
      <h1>
        <i class="fal fa-check-circle"></i>
      </h1>
      <h2>Deal Updated</h2>
    </div>
    <form class="form" @submit.prevent="submit" v-if="form.submitStatus !== 'OK'">
      <Field label="Product" type="black">
        <AutoCompleteInput
          v-model.trim="$v.form.productId.$model"
          :items="productOptions"
          placeholder="Please select a product"
          v-bind:hasError="
            form.submitStatus === 'ERROR' && !$v.form.productId.required
          "
          errorMsg="This field is required"
          :canAdd="false"
        />
      </Field>

      <Field label="Product Image" type="black">
        <ImageItem :src="getProductImage(form.productId)" width="200px" />
      </Field>

      <Field label="Publisher" type="black">
        <SelectInput
          v-model="$v.form.publisherId.$model"
          :modelValue="form.publisherId"
          placeholder="Please select a publisher"
          :options="publisherOptions"
          v-bind:hasError="
            form.submitStatus === 'ERROR' && !$v.form.publisherId.required
          "
          errorMsg="This field is required"
        />
      </Field>

      <Field label="Price" type="black">
        <TextInput v-model.trim="$v.form.price.$model" placeholder="£0.00" />
      </Field>

      <Field label="Url" type="black">
        <TextInput v-model.trim="$v.form.url.$model" placeholder="Product Url" />
      </Field>

      <Field>
        <ButtonSubmit type="secondary">Submit</ButtonSubmit>
      </Field>
    </form>
  </div>
</template>

<script>
import { required, requiredIf, email } from "vuelidate/lib/validators";
import { mapState, mapActions, mapGetters } from "vuex";
import { orderBy } from "lodash";

export default {
  props: {
    dealId: String,
    productId: String,
    mode: String
  },
  computed: {
    ...mapState({
      publishers: state => state.publisher.publishers,
      products: state => state.product.products
    }),
    ...mapGetters({
      getDeal: "deal/getDeal",
      getProductImage: "product/getImage"
    }),
    publisherOptions() {
      return Object.keys(this.publishers).map(id => {
        return {
          text: this.publishers[id].name,
          value: id
        };
      });
    },
    productOptions() {
      let options = Object.keys(this.products).map(id => {
        let product = this.products[id];
        return {
          text: `${product.brand} ${product.name} ${product.edition} ${product.colour}`,
          value: id
        };
      });
      return orderBy(options, "text", "asc");
    }
  },
  data: () => {
    return {
      id: null,
      form: {
        publisherId: null,
        productId: null,
        price: "",
        url: "",
        submitStatus: null
      }
    };
  },
  validations: {
    form: {
      publisherId: {
        required
      },
      productId: {
        required
      },
      price: {
        required
      },
      url: {
        required
      }
    }
  },
  methods: {
    ...mapActions({
      addDeal: "deal/addDeal",
      editDeal: "deal/editDeal"
    }),
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.form.submitStatus = "ERROR";
      } else {
        this.form.submitStatus = "OK";
        this.$emit("onSubmit");

        switch (this.mode) {
          case "edit":
            this.editDeal(this.form);
            break;
          case "duplicate":
            delete this.form.id;
            this.addDeal(this.form);
            break;
          default:
            this.addDeal(this.form);
            break;
        }
      }
    }
  },
  watch: {
    dealId: {
      immediate: true,
      handler(value) {
        this.id = value;
        if (this.id) {
          this.deal = this.getDeal(this.id);
          this.form.id = this.deal.id;
          this.form.publisherId = this.deal.publisherId;
          this.form.productId = this.deal.productId;
          this.form.price = this.deal.price;
          this.form.url = this.deal.url;
        }
      }
    },
    productId: {
      immediate: true,
      handler(value) {
        if (!this.dealId && value) {
          this.form.productId = value;
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.form__success {
  padding: $padding 0;
  text-align: center;

  h1 {
    color: $secondary;
    font-size: 4.8rem;
  }

  h2 {
    color: $primary;
    font-size: 2.4rem;
    font-weight: 400;
  }
}
</style>
